const categoryOptions = [
    'Clinical',
    'Operational',
    'Corporate'
]

export default categoryOptions